import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
}
export function Badge({
  children,
  icon
}: BadgeProps) {
  return <div className="inline-flex gap-1 px-2 py-0.5 md:px-3 md:py-1 rounded-full bg-[#0d3354] border border-sky-400/30 text-slate-200 md:text-xs whitespace-nowrap font-medium font-sans items-center justify-center text-[9px] leading-tight shadow-md" data-id="element-273">
      {icon && <span className="flex items-center text-[10px] md:text-xs" data-id="element-274">{icon}</span>}
      {children}
    </div>;
}